import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.693297, 166.966857, 317.8],
  [-11.693226, 166.966943, 317.4],
  [-11.693165, 166.967028, 317],
  [-11.69311, 166.967125, 316.6],
  [-11.693063, 166.967211, 316.2],
];

export default stream;
